/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Kontaktaufnahmefestnetznummer1Inputs */

const de__field_kontaktaufnahmefestnetznummer1 = /** @type {(inputs: _Field_Kontaktaufnahmefestnetznummer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktaufnahme Festnetznummer`)
};

/**

* @param {_Field_Kontaktaufnahmefestnetznummer1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_kontaktaufnahmefestnetznummer1 = /** @type {((inputs?: _Field_Kontaktaufnahmefestnetznummer1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Kontaktaufnahmefestnetznummer1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_kontaktaufnahmefestnetznummer1(inputs)
});
export { _field_kontaktaufnahmefestnetznummer1 as "_field_kontaktaufnahmeFestnetznummer" }